import {
  HttpInterceptorFn,
  HttpRequest,
  HttpHandlerFn,
  HttpErrorResponse,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { ApiHealthService } from '../../services/api.health.service';

export const errorInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
) => {
  const _healthService = inject(ApiHealthService);
  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      // 0 = Network error / CORS / Server down
      // 502/503/504 = Server infrastructure issues
      if (error.status === 0 || error.status >= 502) {
        _healthService.updateStatus(false);
      }

      return throwError(() => error);
    }),
  );
};
